import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { customerApi } from '../lib/api';

// Handles Google OAuth return with session_id in URL fragment.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/customer/login');
      return;
    }
    const session_id = match[1];

    const exchange = async () => {
      try {
        const r = await customerApi.post('/auth/session', { session_id });
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/portal', { state: { user: r.data } });
      } catch (err) {
        console.error('Auth callback failed:', err);
        navigate('/customer/login');
      }
    };
    exchange();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center hero-bg">
      <div className="text-center fade-in">
        <Logo size="lg" />
        <div className="mt-6 text-sm text-[#6b7280]">Signing you in...</div>
      </div>
    </div>
  );
}
